var _rect, _rect2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnknownUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#363539"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#191724"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.341 176.731C193.693 173.734 194.668 170.354 194.668 166.651C194.665 141.76 194.68 116.87 194.634 91.9795C194.634 90.2496 194.403 88.4703 193.955 86.8011C191.785 78.7243 184.706 73.4094 176.201 73.4056C143.643 73.3942 111.089 73.3942 78.5319 73.4283C77.1206 73.4283 76.0167 73.1704 75.0113 72.1119C73.8732 70.9169 72.5871 69.8547 71.3201 68.7886C69.5446 67.2977 67.4922 66.9563 65.3336 67.7416C63.1105 68.5496 61.7941 70.2075 61.4451 72.5596C61.0543 75.1924 62.3669 77.0285 64.2296 78.7016C99.9777 110.846 135.707 143.009 171.44 175.168C175.764 179.06 180.074 182.971 184.429 186.833C187.077 189.182 190.825 188.996 193.079 186.492C195.344 183.973 195.116 180.308 192.533 177.842C192.161 177.489 191.785 177.144 191.338 176.727L191.341 176.731ZM182.521 166.488C182.521 167.083 182.438 167.683 182.381 168.491C181.941 168.199 181.667 168.062 181.447 167.865C177.786 164.58 174.141 161.275 170.461 158.009C169.831 157.451 169.577 157.015 169.907 156.104C170.696 153.931 170.563 151.726 169.52 149.632C162.452 135.47 155.442 121.282 148.268 107.173C145.187 101.115 137.228 100.838 133.503 106.528C131.302 109.89 129.235 113.338 127.103 116.745C126.829 117.181 126.541 117.602 126.196 118.129C123.123 115.368 120.137 112.686 117.152 110C115.289 108.323 113.4 106.669 111.583 104.946C111.237 104.616 110.938 103.975 110.991 103.524C111.677 97.9394 106.689 92.8445 100.471 94.233C100.156 94.305 99.6817 94.2519 99.4579 94.0547C96.6544 91.5812 93.8888 89.0697 91.1042 86.5773C90.8311 86.3345 90.5124 86.141 90.2165 85.921C90.2923 85.792 90.3644 85.663 90.4403 85.534H91.844C119.804 85.534 147.767 85.534 175.726 85.534C179.368 85.534 181.758 87.2791 182.396 90.4165C182.517 91.0121 182.517 91.6381 182.517 92.2527C182.521 116.995 182.521 141.741 182.517 166.484L182.521 166.488Z",
    fill: "url(#paint0_linear_5310_16960)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.818 171.529C152.46 170.516 150.901 170.296 149.254 170.296C126.401 170.308 103.544 170.232 80.6906 170.361C75.7436 170.387 73.3991 167.113 73.4219 163.149C73.5471 142.758 73.4788 122.363 73.4788 101.968C73.4788 101.448 73.494 100.925 73.4674 100.405C73.3081 97.1423 70.7018 94.6423 67.4506 94.6309C63.8238 94.6233 61.3465 97.3168 61.3427 101.334C61.3352 122.105 61.3276 142.879 61.3427 163.65C61.3503 174.557 69.2602 182.436 80.1595 182.44C91.514 182.447 102.872 182.44 114.227 182.44C125.866 182.44 137.509 182.44 149.148 182.44C149.668 182.44 150.191 182.459 150.707 182.417C153.162 182.212 155.294 180.471 155.996 178.115C156.713 175.714 155.829 173.028 153.814 171.525L153.818 171.529Z",
    fill: "url(#paint1_linear_5310_16960)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7494 161.834C107.28 161.853 119.807 161.841 132.337 161.834C132.751 161.834 133.164 161.792 134.018 161.75C121.533 150.513 109.359 139.553 97.1015 128.518C96.9612 128.726 96.8663 128.832 96.8056 128.958C93.323 135.927 89.8252 142.892 86.373 149.876C85.5042 151.629 85.398 153.518 85.8798 155.411C86.9155 159.47 90.1515 161.83 94.7532 161.834H94.7494Z",
    fill: "url(#paint2_linear_5310_16960)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5310_16960",
    x1: 36.8597,
    y1: 127.91,
    x2: 203.411,
    y2: 217.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#6A19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3054BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5310_16960",
    x1: 43.8777,
    y1: 138.537,
    x2: 163.396,
    y2: 201.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#6A19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3054BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5310_16960",
    x1: 76.6883,
    y1: 145.181,
    x2: 128.598,
    y2: 181.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#6A19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3054BB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownUserAvatar);
export default __webpack_public_path__ + "static/media/UnknownUserAvatar.bc2860298399748a4dd9380fe4f04055.svg";
export { ForwardRef as ReactComponent };